var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    { attrs: { "no-margin": "", "no-padding": "" } },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c("app-sale-type-list", {
                    attrs: { types: _vm.types, "contact-group-id": 1 },
                    on: {
                      order: function ($event) {
                        return _vm.setSaleOrder()
                      },
                      refresh: function ($event) {
                        return _vm.refresh()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c("app-sale-type-list", {
                    attrs: { types: _vm.purchaseTypes, "contact-group-id": 2 },
                    on: {
                      order: function ($event) {
                        return _vm.setPurchaseOrder()
                      },
                      refresh: function ($event) {
                        return _vm.refresh()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }